import { render } from "./TemporaryDamagedGoodsTable.vue?vue&type=template&id=56bea4a6"
import script from "./TemporaryDamagedGoodsTable.vue?vue&type=script&lang=js"
export * from "./TemporaryDamagedGoodsTable.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__